import { PayloadAction } from '@reduxjs/toolkit';
import { NormalizedV2Response } from '@/types/eds/api/responses/NormalizedV2Response';
import { RootState } from '@/store/types/RootState';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { EdsDefinitionSections } from '@/features/eds/enums/EdsDefinitionSections';
import { EdsEntityCodes } from '@/features/eds/enums/EdsEntityCodes';
import EdsAdapterService from '@/features/eds/services/EdsAdapterService/EdsAdapterService';
import HttpService from '@/services/HttpService/HttpService';
import QueryParamsService from '@/services/QueryParamsService/QueryParamsService';
import {
  getPotentialPoliciesFilteredList,
  getPotentialPoliciesListSuccess,
  incrementPotentialPoliciesListPage,
  setPotentialPoliciesListLoadingStatus,
} from '../store/policySlice';

function* getPotentialPoliciesFilteredListSaga({ type }: PayloadAction<undefined>) {
  try {
    yield put(setPotentialPoliciesListLoadingStatus(true));

    const pagination = yield select((state: RootState) => state.policySlice.data.pagination);
    const savedFilters = yield select((state: RootState) => state.policySlice.savedFiltersForSending);
    const savedSorting = yield select((state: RootState) => state.policySlice.savedSortingForSending);

    const requestUrl = `/filter/${EdsEntityCodes.ClaimSetPolicyMatch}?${QueryParamsService.constructSearchParamsFromRecord({ page: pagination.page, perPage: pagination.perPage, sortBy: savedSorting?.propertyName, sortDirection: savedSorting?.sortDirection, includes: `${EdsEntityCodes.Policy},${EdsEntityCodes.HelperTags}` })}`;

    const { data } = yield call(HttpService.post, requestUrl, savedFilters?.filters ?? [], {
      baseURL: import.meta.env.VITE_API_URL_EDS,
    });

    const normalizedResponse: NormalizedV2Response[] = yield call(EdsAdapterService.normalize, data.listings, {
      section: EdsDefinitionSections.SidePanel,
      includeId: true,
    });
    const transformedResponse = normalizedResponse.map((item) => ({ ...item, ...item.entities }));

    yield put(
      getPotentialPoliciesListSuccess({
        shouldRewrite: type !== incrementPotentialPoliciesListPage.type,
        data: {
          listings: transformedResponse as any,
          pagination: {
            ...data.pagination,
            isLastPage: pagination.page * pagination.perPage >= pagination.numberOfItems,
          },
        },
      }),
    );
  } catch (error) {
    console.error(error);
  } finally {
    yield put(setPotentialPoliciesListLoadingStatus(false));
  }
}

export function* potentialPoliciesWatcher() {
  yield takeLatest(
    [getPotentialPoliciesFilteredList.type, incrementPotentialPoliciesListPage.type],
    getPotentialPoliciesFilteredListSaga,
  );
}
